__turbopack_context__.v({
  "button": "button-module__jTanvW__button",
  "dark": "button-module__jTanvW__dark",
  "default": "button-module__jTanvW__default",
  "destructive": "button-module__jTanvW__destructive",
  "ghost": "button-module__jTanvW__ghost",
  "link": "button-module__jTanvW__link",
  "primary": "button-module__jTanvW__primary",
  "secondary": "button-module__jTanvW__secondary",
  "size-default": "button-module__jTanvW__size-default",
  "size-icon": "button-module__jTanvW__size-icon",
  "size-lg": "button-module__jTanvW__size-lg",
  "size-sm": "button-module__jTanvW__size-sm",
  "size-xl": "button-module__jTanvW__size-xl",
  "size-xs": "button-module__jTanvW__size-xs",
});
